
import { ApiURLs } from "../../../constant/ApiUrls";
import { deleteData, fetchData, postData, updateData } from "../../../services/api";
import { hideAddFaqsModal } from "./faqsModalDispatcher";

  

  export const addFaqsRequest = (data, navigate) => {
    return async (dispatch) => {
      dispatch({"type":"ADD_FAQS_REQUEST"});
      try {
        var faqsResponse = (data.id)? await updateData(data, `${ApiURLs.FAQS}/${data.id}`):await postData(data, ApiURLs.FAQS);
        if (faqsResponse.status === 1) {
          dispatch({"type":"ADD_FAQS_SUCCESS"});
          dispatch(hideAddFaqsModal());
          dispatch(faqsLisitingRequest());
        } else {
          dispatch({"type":"ADD_FAQS_FAILED"});
        }
      } catch (error) {
        dispatch({"type":"ADD_FAQS_FAILED"});
  
      }
    };
  };




  export const faqsLisitingRequest = () => {

    return async (dispatch) => {

      const url = `${ApiURLs.FAQS}?limit=50`;
  
      // wait untill the data not received so getData function take data and url part
      dispatch({"type":"GET_FAQS_REQUEST"});
      try {
        var faqsData = await fetchData(url);
        console.log(`response when we try to get faqs  ${JSON.stringify(faqsData)}`)
        if (faqsData.status === 1) {
          dispatch({"type":"GET_FAQS_REQUEST_SUCCESS", "payload":faqsData.data.result});
        
        } else {
          dispatch({"type":"GET_FAQS_REQUEST_FAILED"});
        }
      } catch (error) {
        dispatch({"type":"GET_FAQS_REQUEST_FAILED"});
        console.log(`error while try to get faqs  ${error}`)
      }
    }
  };



    export const deleteFaqs = (id) => {
      return async (dispatch) => {
    
        // dispatch();
        dispatch({"type":"DELETE_FAQS_REQUEST"});
        try {
    
  
          var faqsResponse = await deleteData(`${ApiURLs.FAQS}/${id}`);
          if (faqsResponse.status === 1) {
            dispatch({"type":"ADD_FAQS_SUCCESS"});
            dispatch(faqsLisitingRequest());
          } else {
            dispatch({"type":"ADD_FAQS_FAILED"});
          }
        } catch (error) {
          dispatch({"type":"ADD_FAQS_FAILED"});
    
        }
      };
    };
  

  
 